<template>
  <b-row>

    <b-col
      v-if="!me.organization.subscriptionActive"
      cols="12"
      xl="10"
    >
      <b-alert
        :show="me.organization.subscriptionType === 'Trial'"
        variant="danger"
        class="p-1 mb-2 text-center shadow"
      >
        <p>
          Twój darmowy okres próbny zakończył sie
          {{ transformDateToHumanReadablePretty(me.organization.subscriptionEndsAt) }},
          o godzinie
          {{ transformTimeToHumanReadablePretty(me.organization.subscriptionEndsAt) }}.
          Aby móc nadal korzystać z aplikacji, wybierz poniżej płatność roczną lub miesięczną, a następnie przejdź do płatności, w celu uruchomienia subskrypcji.
        </p>
        <p>
          Jeżeli masz pytania, pisz do nas na adres
          <a
            class="text-danger"
            href="mailto:hi@totedi.com"
            target="_blank"
          >
            <b>hi@totedi.com</b>
          </a>.
        </p>
      </b-alert>
    </b-col>

    <b-col xl="10">
      <b-card
        v-if="!me.organization.subscriptionExternalId"
        id="newSubscriptionCard"
      >
        <b-row>
          <b-col
            md="6"
            class="mb-5"
          >

            <b-row>
              <b-col
                cols="10"
                offset="1"
                class="text-center mt-1 d-inline-flex justify-content-center"
              >
                <b-button
                  :variant="selected === 'Monthly' ? 'outline-primary' : 'flat-secondary'"
                  class="mx-1"
                  size="sm"
                  pill
                  style="flex: 1 1 0;"
                  @click="selected = 'Monthly'"
                >
                  Miesięczna
                </b-button>
                <b-button
                  :variant="selected === 'Yearly' ? 'outline-primary' : 'flat-secondary'"
                  class="mx-1"
                  size="sm"
                  pill
                  style="flex: 1 1 0;"
                  @click="selected = 'Yearly'"
                >
                  Roczna
                </b-button>
              </b-col>
            </b-row>
            <div
              v-if="selected === 'Monthly'"
              class="font-large-5 text-center mb-n1 font-weight-bold mt-2"
            >
              <span>
                {{ priceMonthly }}
              </span>
              <span class="period font-large-2">
                zł
              </span>
            </div>
            <div
              v-if="selected === 'Yearly'"
              class="font-large-5 text-center mb-n1 font-weight-bold mt-2"
            >
              <span>
                {{ priceMonthly }}
              </span>
              <span class="period font-large-2">
                zł
              </span>
            </div>
            <div class="text-center font-medium-2">
              / miesiąc
              <span v-if="parseInt(additionalEducators) > 1">
                za {{ parseInt(additionalEducators) }} nauczycieli
              </span>
            </div>

            <p
              v-if="selected === 'Yearly'"
              class="mt-1 mb-2 text-center text-muted"
            >
              {{ priceYearly }} zł / rok
            </p>

            <p
              v-if="selected === 'Monthly'"
              class="mt-1 mb-2 text-danger text-center"
            >
              Zaoszczędź 20% wybierając płatność roczną.
            </p>

            <b-row>
              <b-col
                cols="10"
                offset="1"
              >
                <div class="d-flex justify-content-between text-center">
                  <span>1</span>
                  <span>5</span>
                  <span>10</span>
                </div>
              </b-col>
              <b-col
                cols="10"
                offset="1"
                class="text-center"
              >
                <b-form-input
                  v-model="additionalEducators"
                  type="range"
                  min="1"
                  max="10"
                />
                Liczba nauczycieli
              </b-col>
            </b-row>
            <!--            <VSlider-->
            <!--              v-model="value"-->
            <!--              :error="value > 40"-->
            <!--              :rules="rules"-->
            <!--              :step="10"-->
            <!--              thumb-label="always"-->
            <!--              show-ticks-->
            <!--            />-->

            <div class="mt-3 text-center">
              <b-button
                variant="primary"
                :disabled="loadingRedirectUrl"
                @click="redirect"
              >Przejdź do płatności</b-button>
            </div>
          </b-col>
          <b-col md="6">
            <h4 class="mt-2">
              W cenie otrzymujesz
            </h4>
            <ul class=" text-left mt-2">
              <li class="mb-25">
                Nielimitowaną liczbę spotkań
              </li>
              <li class="mb-25">
                Nielimitowaną liczbę uczniów
              </li>
              <li class="mb-25">
                Darmowe konta w aplikacji dla wszystkich uczniów
              </li>
              <li class="mb-25">
                Zarządzanie uczniami i usługami
              </li>
              <li class="mb-25">
                Zaawansowany kalendarz
              </li>
              <li class="mb-25">
                Narzędzie do udostępniania materiałów edukacyjne
              </li>
              <li class="mb-25">
                Automatyzację powiadomień
              </li>
              <li class="mb-25">
                Zarządzanie nauczycielami
              </li>
              <li
                v-for="capability in capabilities.list"
                v-show="capability.soon"
                :key="capability.id"
                class="mb-25"
              >
                <span v-html="capability.heading" />
                <b-badge
                  size="sm"
                  variant="light-primary"
                  class="ml-50"
                >
                  Wkrótce
                </b-badge>
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-card>

      <b-card v-else>
        <p class="mb-2">
          Twoja subskrypcja Totedi zakończyła się
          {{ transformDateToHumanReadablePretty(me.organization.subscriptionEndsAt) }},
          o godzinie
          {{ transformTimeToHumanReadablePretty(me.organization.subscriptionEndsAt) }},
          ponieważ nie udało się pobrać płatności.
          Najczęstszą przyczyną jest brak środków na karcie lub jej wygaśnięcie.
        </p>
        <p>
          Jeśli chcesz dalej korzystać z aplikacji, skorzystaj z dostępnych opcji:
        </p>
        <div class="d-flex justify-content-center mb-2">
          <b-button
            variant="primary"
            class="mr-1"
            :disabled="processingRetry || processingPortal"
            @click="retryPayment"
          >
            <b-spinner
              v-if="processingRetry"
              small
              class="mr-50"
            />
            Ponów płatność
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="processingRetry || processingPortal"
            @click="openPortal"
          >
            <b-spinner
              v-if="processingPortal"
              small
              class="mr-50"
            />
            Zaktualizuj metodę płatności
          </b-button>
        </div>
        <p>
          Masz pytania? Napisz do nas na
          <a
            href="mailto:hi@totedi.com"
            target="_blank"
          >
            <b>hi@totedi.com</b>
          </a> – chętnie pomożemy!
        </p>
      </b-card>

      <PricingFaq />
    </b-col>
  </b-row>
</template>

<script>
import dayjs from 'dayjs'
import PricingFaq from '@/views/auth/checkout/PricingFaq'
import { transformDateToHumanReadablePretty, transformTimeToHumanReadablePretty } from '@/helpers/dateTimeHelper'
import { parseRequestError } from '@/helpers/helpers'
import capabilities from './checkout/capabilities.json'

export default {
  components: {
    PricingFaq,
  },
  data() {
    return {
      selected: 'Monthly',
      loadingRedirectUrl: false,
      additionalEducators: 1,
      processingRetry: false,
      processingPortal: false,
      intervalId: null,
      hasTrackedSubscriptionCompletion: false,
      options: [
        { text: 'wybieram płatność za rok z góry', value: 'Yearly' },
        { text: 'wybieram płatność co miesiąc', value: 'Monthly' },
      ],
    }
  },
  computed: {
    capabilities() {
      return capabilities
    },
    priceMonthly() {
      if (this.selected === 'Yearly') {
        return 60 + (20 * (this.additionalEducators - 1))
      }
      return 75 + (25 * (this.additionalEducators - 1))
    },
    priceYearly() {
      if (this.selected === 'Yearly') {
        return 720 + (240 * (this.additionalEducators - 1))
      }
      return 900 + (300 * (this.additionalEducators - 1))
    },
    me() {
      return this.$store.getters['auth/getUser']
    },
  },
  beforeMount() {
    if (this.me.organization.paidSubscriptionActive) {
      this.trackSubscriptionCompletion()
      this.$router.replace({ name: 'dashboard-redirect' })
    }
  },
  mounted() {
    this.intervalId = setInterval(this.checkSubscriptionStatus, 10000)
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  },
  methods: {
    dayjs,
    transformDateToHumanReadablePretty,
    transformTimeToHumanReadablePretty,
    checkSubscriptionStatus() {
      this.$store.dispatch('auth/fetchUserInfo')
        .then(() => {
          if (this.me.organization.paidSubscriptionActive) {
            this.trackSubscriptionCompletion()
            this.$router.replace({ name: 'dashboard-redirect' })
          }
        })
    },
    redirect() {
      this.loadingRedirectUrl = true
      if (this.$gtm) {
        const organization = this.me?.organization || {}
        const educatorsCount = Number.parseInt(this.additionalEducators, 10) || 1

        this.$gtm.trackEvent({
          event: 'subscription_purchase_started',
          category: 'subscription',
          action: 'checkout_start',
          label: this.selected,
          subscriptionInterval: this.selected,
          additionalEducators: educatorsCount,
          organizationId: organization.id || null,
        })
      }
      this.$store.dispatch(
        'auth/prepareRedirectUrl',
        {
          subscriptionInterval: this.selected,
        },
      )
        .then(response => {
          window.location.href = response.data.checkoutUrl
        })
        .catch(err => parseRequestError(err))
        .finally(() => {
          this.loadingRedirectUrl = false
        })
    },
    retryPayment() {
      this.processingRetry = true
      this.$store.dispatch('auth/retryPayment')
        .catch(err => parseRequestError(err))
        .finally(() => {
          this.processingRetry = false
        })
    },
    openPortal() {
      this.processingPortal = true
      this.$store.dispatch('auth/createPortalSession')
        .then(res => {
          window.location.href = res.data.url
        })
        .catch(err => {
          this.processingPortal = false
          parseRequestError(err)
        })
    },
    trackSubscriptionCompletion() {
      if (this.hasTrackedSubscriptionCompletion) {
        return
      }

      this.hasTrackedSubscriptionCompletion = true

      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }

      if (this.$gtm) {
        const organization = this.me?.organization || {}
        const subscriptionType = organization.subscriptionType || null

        this.$gtm.trackEvent({
          event: 'subscription_purchase_completed',
          category: 'subscription',
          action: 'checkout_complete',
          label: subscriptionType || 'unknown',
          subscriptionInterval: subscriptionType,
        })
      }
    },
  },
}
</script>
